import request from './api'

/**
 * @module 教学班
 */

/**
 * 实训
 */
// 查询目录
export const QueryCourseByIdAndType = (params, opts) =>
  request('/api-course/catalog/queryCourseByIdAndType', params, {
    ...opts,
    method: 'post'
  });

// 查询进度
export const GetResourceRecord = (courseId, classId, opts) =>
  request(`/api-study/resourceRecord/getRecord/${courseId}/${classId}`, opts); // params {id: ''}

// 查询总进度
export const GetTotalProgress = (params, opts) =>
  request('/api-study/resourceRecord/getProgress', params, {
    ...opts,
    method: 'post'
  });

// 教学班中全部的学员列表
export const GetStudentList = (params, opts) =>
  request('/api-course/class/get', params, {
    ...opts,
    method: 'post'
  });

// 获取课程是否自动编号
export const getCourseAutomatic = (params, opts) => request('/api-course/courseSet/queryCourseSet', params, { ...opts, method: 'post' });

// 实训、课程目录 章节开关
export const BatchUpdateSet = (params, opts) =>
  request('/api-course/classSet/batchUpdateSet', params, {
    ...opts,
    method: 'post'
  });

//查询目录学习位置
export const SelectDirectory = (params, opts) => request('/api-study/study/qryResDetail', params, {
  ...opts,
  method: 'post'
});


/**
 * @module 课程库
 */

/**
 * 试题
 */

// 根据科目查询题型
export const FindTypeBySubject = (params, opts) =>
  request('/api-resource/questionType/select', params, opts); // params {id: ''}
// 查询题型 -- 标准模式
export const findTypeByModel = (params, opts) =>
  request('/api-resource/questionType/query', params, { ...opts, method: 'post' });  

// 根据课程id查询资源分类接口
export const FindResCategoryByCourseId = (params, opts) =>
  request(`/api-course/categoryResource/findResCategoryByCourseId?courseId=${params}`, opts); // params {id: ''}

// 查询课程 - 查询素材接口
export const FindPageResource = (params, opts) =>
  request('/api-course/categoryResource/findPage/resource', params, {
    ...opts,
    method: 'post'
  });


// 获取教学班 共享资源列表
export const resourceByCatalogIdList = (params, opts) =>
  request("/api-course/categoryResource/findPage/resourceByCatalogId", params, {
    ...opts, method: "post"
  });


//获取弹窗试题列表
export const QueryQuestionList = (params, opts) => request("/api-resource/question/select", params, {
  ...opts,
  method: "post"
});
//获取弹窗试题列表 - 不包含加密试题
export const SelectNoEncryptionQuestion = (params, opts) => request("/api-resource/question/selectNoEncryption", params, {
  ...opts,
  method: "post"
});

// 课程库保存资源接口：
export const AddResource = (params, opts) =>
  request('/api-course/categoryResource/add/resource', params, {
    ...opts,
    method: 'post'
  });

// 删除课程库资源接口：
export const DeleteResource = (params, opts) =>
  request('/api-course/categoryResource/delete/resource', params, {
    ...opts,
    method: 'post'
  });
// 删除课程库资源接口新：
export const DeleteResourceByCourse = (params, opts) =>
  request('/api-course/categoryResource/deleteResource', params, {
    ...opts,
    method: 'post'
  });

// 根据id查询试题详情
export const QueryQuestionById = (params, opts) =>
  // request(`/api-resource/question/getById/${params}`, opts); // params {id: ''}
  request(`/api-resource/question/getByIdNoPermission/${params}`, opts); // params {id: ''}

// 查询科目下的公司
export const FindCompanyBySubjectId = (params, opts) =>
  request('/api-resource/company/query/by/lable', params, {
    ...opts,
    method: 'post'
  });

/**
 * 试卷
 */

// 获取所有的测验试卷
export const SelectTestPaPerByPaperType = (params, opts) =>
  request('/api-resource/testPaper/selectTestPaPerByPaperType', params, {
    ...opts,
    method: 'post'
  });


/**
 * 课程预览
 */

// 添加富文本：
export const categoryResourceAddImageText = (params, opts) =>
  request('/api-course/categoryResource/add/imageText', params, {
    ...opts,
    method: 'post'
  });
// 修改富文本：
export const categoryResourceUpdateImageText = (params, opts) =>
  request('/api-course/categoryResource/update/imageText', params, {
    ...opts,
    method: 'post'
  });

// 添加链接
export const categoryResourceAddLink = (params, opts) =>
  request('/api-course/categoryResource/add/link', params, {
    ...opts,
    method: 'post'
  });

// 修改链接
export const categoryResourceUpdateLink = (params, opts) =>
  request('/api-course/categoryResource/update/link', params, {
    ...opts,
    method: 'post'
  });

// 资源批量开启或关闭下载接口
export const categoryResourceDownloadResource = (params, opts) =>
  request('/api-course/categoryResource/download/resource', params, {
    ...opts,
    method: 'post'
  });

// 根据资源id查询共享资源
export const CategoryResourceFindById = (params, opts) =>
  request('/api-course/categoryResource/findById', params, opts); // params {id: ''}

// 根据资源id查询共享资源
export const getJupyterTaskRecord = (params, ) =>
  request('/api-eval/jupyterTaskRecord/query', params, { method: 'post'});

// 查询是否是助教
export const judgeAssistant = (params, opts) =>
  request('/api-course/classAssistant/judgeAssistant', params, {
    ...opts,
    method: 'post'
  });
// 根据科目查询是否有资源库权限 >>新加
export const getPermission = (params, opts) =>
  request(`/api-resource/cjdd-resources/teacher/subject/permission/${params}`, opts);
// 查询资源库(有权限)试题列表
export const queryTestResourceData = (params, opts) =>
  request('/api-resource/question/list', params, {
    ...opts,
    method: 'post'
  });


// 根据资源id查询共享资源
export const findPageTestPaper = (params, ) =>
  request('/api-course/categoryResource/findPageTestPaper', params, { method: 'post'});

// 推送阅卷
export const ArtificialScore = (params, opts) =>
  request('/api-study/artificialScore', params, {
    ...opts,
    method: 'post'
  });

// 重置阅卷-教学
export const resetGrading = (classId, courseId, opts) =>
  request(`/api-score/resetGrading/${classId}/${courseId}`, opts);
// 重置阅卷-测评
export const resetGrading2 = (classId, courseId, examId, paperId, opts) =>
  request(`/api-study/resetGrading/${classId}/${courseId}/${examId}/${paperId}`, opts);

// 是否展示阅卷按钮
export const isSubjective = (courseId, paperId, opts) =>
  request(`/api-study/isSubjective/${courseId}/${paperId}`, opts);

// 组卷校准-是否阅卷
export const publishPaperCorrection = (params, opts) =>
  request('/api-resource/testPaper/publishPaperCorrection', params, {
    ...opts,
    method: 'post'
  });


// WEBPACK FOOTER //
// ./src/api/newCourseApi.js